import { GroupTableColumn, TableColumn } from './tableTypes'
import { toFuncAccessor } from './cellAccessor'

import { isNotNull, PartialMap, SplitPick } from '../common/tsUtils'

export type MyColumnParam<TColumnId extends string, TRow extends object> =
  SplitPick<
    PartialMap<TableColumn<TColumnId, TRow>, 'accessor'>,
    // Allow only one of these props during creation. DU types won't work in table types, but seems to work here.
    'cellStyle', 'CellComponent'>

export type GroupedMyColumnsParam<TGroupColumnId extends string, TRow extends object> =
  Array<MyColumnParam<TGroupColumnId, TRow> | null>

export const createColumns =
  <TColumnId extends string, TRow extends object>
  (...columns: Array<MyColumnParam<TColumnId, TRow> | null>): Array<TableColumn<TColumnId, TRow>> =>
    columns.filter(isNotNull)
           .map(createColumn)

export const createColumnGroup =
  <TColumnId extends string, TRow extends object>() =>
    <TGroup>(group: TGroup, columns: GroupedMyColumnsParam<TColumnId, TRow>)
      : Array<GroupTableColumn<TGroup, TColumnId, TRow>> =>
      columns.filter(isNotNull)
             .map(column => ({group, ...createColumn(column)}))

export const createColumn =
  <TColumnId extends string, TRow extends object>
  ({accessor, ...column}: MyColumnParam<TColumnId, TRow>): TableColumn<TColumnId, TRow> =>
    ({
      ...column,
      accessor: toFuncAccessor(accessor ?? column.id)
    })